import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, NgModule, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { Route, Router, RouterModule } from '@angular/router';
import { RouteData } from '@app/common/route-data';
import { LogoModule } from '@app/components/header/logo/logo.component';
import { SearchFormModule } from '@app/components/header/search-form/search-form.component';
import { TopnavBroadcastsModule } from '@app/components/header/topnav-broadcasts/topnav-broadcasts.component';
import { UserMenuModule } from '@app/components/header/user-menu/user-menu.component';
import { FeatureToggleModule } from '@app/directives/feature-toggle.directive';
import { ExtendedRoute } from '@app/models/extended-route';
import { BadgeMenuService } from '@app/services/badge-menu.service';
import { FeatureSettingsStoreService } from '@app/services/feature-settings-store.service';
import { LicenseService } from '@app/services/license.service';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { LinkModule } from '@app/directives/link.directive';
import { ActionLinkModule } from '@app/components/actions/action-link/action-link.component';

@Component({
  selector: 'app-topnav',
  templateUrl: './topnav.component.html',
  styleUrls: ['./topnav.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TopnavComponent implements OnInit {

  @Input() sideMenuIsOpen = false;
  @Input() displayMode: 'vertical' | 'horizontal';
  @Output() toggleSideMenuEvent = new EventEmitter<boolean>();

  featureSettings = this.featureSettingsStoreService.state;
  workplaceName = this.featureSettingsStoreService.state.workplaceName;
  bypassLicenseFilterInTopNav = this.featureSettingsStoreService.state.bypassLicenseFilterInTopNav;
  routeLinks$: Observable<ExtendedRoute[]>;
  guideUrl = this.featureSettingsStoreService.state.guideSiteUrl;
  additionalTopNavLink = this.featureSettingsStoreService.state.linkTopNav;

  constructor(private featureSettingsStoreService: FeatureSettingsStoreService,
              private badgeMenuService: BadgeMenuService,
              private licenseService: LicenseService,
              private cdr: ChangeDetectorRef,
              public router: Router) {
  }

  toggleSideMenu() {
    this.sideMenuIsOpen = !this.sideMenuIsOpen;
    this.toggleSideMenuEvent.emit(this.sideMenuIsOpen);
  }

  licenseFilter(route: Route, hasUserAny365License: boolean): boolean {
    if (route.data?.hasOwnProperty('onlyShowForLicensedUsers')) {
      if (hasUserAny365License === (route.data as RouteData)?.onlyShowForLicensedUsers || this.bypassLicenseFilterInTopNav) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  ngOnInit() {
    this.routeLinks$ =
      this.licenseService.hasUserAny365License()
        .pipe(
          map(hasUserAny365License => {
            // Only show routes that have the data.title property defined.
            // Also filter where where 'showForLicensedUsers' is either not defined or is equal to the license requirements
            return this.router.config
              .filter(route => route.data?.title && route.data?.showInTopNav && this.licenseFilter(route, hasUserAny365License))
              .map(route => {
                return {
                  path: route.path,
                  data: route.data,
                  showBadge$: this.badgeMenuService.showBadge(route)
                    .pipe(
                      tap(() => {
                        this.cdr.detectChanges();
                      }))
                } as ExtendedRoute;
              });
          }));

  }

}
@NgModule({
  declarations: [TopnavComponent],
  exports: [TopnavComponent],
  imports: [
    CommonModule,
    RouterModule,
    MatBadgeModule,
    LogoModule,
    SearchFormModule,
    FeatureToggleModule,
    TopnavBroadcastsModule,
    UserMenuModule,
    LinkModule,
    ActionLinkModule
  ]
})
export class TopnavModule { }
